interface AutocompleteItemInterface {
  name: string
  id: string
}

export default (value: string, options: AutocompleteItemInterface[]) => {
  if (value === '') {
    return []
  }

  const filterAirportOptions = (option: AutocompleteItemInterface) =>
    option.name.toLowerCase().includes(value.toLowerCase()) ||
    option.id.toLowerCase().includes(value.toLowerCase())

  return options.filter(filterAirportOptions)
}
